import styled, { css } from 'styled-components';
import classnames from 'classnames';
import { boxNoHeight } from '../../modules/style/defaults';
import { dashboard } from '../../modules/style/mixins/dashboard';
import { calcStyle } from '../../modules/style/methods/calcStyle';

export const SlideDownBoxStyle = styled.div.attrs((props) => ({
	className: classnames(props.className, 'slide-down__box'),
}))<{
	type?: string;
	noDashboard?: boolean;
}>`
	${boxNoHeight};
	${(props) =>
		props.noDashboard
			? ''
			: dashboard(
					(padding) => css`
						margin: 0 -${padding};
						width: calc(100% + ${calcStyle({ a: padding, b: 2, mode: '*' })});
					`,
			  )}

	&:last-of-type {
		margin-bottom: -7px;
	}
`;

export const SlideDownTitleStyle = styled.div.attrs((props) => ({
	className: classnames(props.className, 'slide-down__title'),
}))<{
	isColor?: boolean;
	name: string;
}>`
	${boxNoHeight};
	cursor: pointer;
	margin-bottom: 0;
	margin-top: 15px;

	&.icon-wrapper {
		padding-right: 30px !important;

		[class*='icon'] {
			right: 13px;
		}
	}

	${(props) =>
		props.isColor
			? `
    border-radius: ${props.theme.layout.borderRadius};
    background-color: ${props.theme.colors.inputButton};
    padding: 10px;
  `
			: ''}
`;

export const SlideDownContentStyle = styled.div.attrs((props) => ({
	className: classnames(props.className, 'slide-down__content'),
}))<{
	isActive: boolean;
}>`
	${boxNoHeight};
	max-height: ${(props) => (props.isActive ? '300vh' : '0')};
	transition: ${(props) => (props.isActive ? '0.2s ease-in' : '0')};
	overflow: ${(props) => (props.isActive ? 'unset' : 'hidden')};
	height: auto;
`;
